<template lang="pug">
.remission-container(v-if="order")
  img.logo(:src="`${imagePath}/others/logo-print.png`")
  .remission-subtitle Remisión
  div Calle 37 B sur 68 I 23 - Bogotá, Colombia - 350 750 1085

  .top-remission-container
    .customer-container
      .customer-name
        span.dark Cliente:
        span.capitalize  {{ order.name }}
      .customer-phones
        span.dark Telefono:
        span  {{ order.phones[0] }}
      .customer-location
        span.dark Ubicación:
        span.capitalize  {{ order.location }} - {{ order. department }}
      .customer-address
        span.dark Dirección:
        span.uppercase  {{ order.address }}

    .order-container
      .order-id.dark
        span Orden:
        span.uppercase  {{ order.order }}
      .order-date
        span.dark Fecha:
        span  {{ dateTime(order.createdAt) }}

  // .order-products(v-if="false")
    .row-container-title
      .product-row-reference Referencia
      .product-row-description Descripción
      .product-row-price Precio
      .product-row-quantity Cantidad
      .product-row-subtotal Subtotal
    div(v-for="product in order.cart")
      .row-container(v-for="(size, index) in product.sizes" v-if="product.quantityCart[index]")
        .product-row-reference.uppercase {{ product.product-row }} - {{ size }}
        .product-row-description.capitalize {{ personSpanish(product.person) }} - {{ articleSpanish(product.article) }}
        .product-row-price {{ money(product.priceWholesaler) }}
        .product-row-quantity {{ product.quantityCart[index] }}
        .product-row-subtotal {{ money(product.quantityCart[index] * product.priceWholesaler) }}

  .order-products
    .row-container-title
      .product-row-description Descripción
      .product-row-price Precio
      .product-row-quantity Cantidad
      .product-row-subtotal Subtotal
    div
      .row-container(v-for="(product, index) in productsByArticle")
        .product-row-description.capitalize {{ product.article }}
        .product-row-price {{ money(product.price) }}
        .product-row-quantity {{ product.quantity }}
        .product-row-subtotal {{ money(product.price * product.quantity) }}

  .order-totals
    .row-container.totals
      .product-row-description
      .product-row-price
      .product-row-quantity.dark {{ order.quantity }}
      .product-row-subtotal.dark {{ money(order.total) }}

  .order-totals.explication(v-if="order.methodPay === 'credit'")
    .row-container.totals.before
      .row-complete.right Pago Normal (-0%):
      .product-row-subtotal.dark {{ money(order.total) }}

    .row-container.totals.before
      .row-complete.right Antes del {{ date(addDays(order.createdAt, 31)) }} (-5%):
      .product-row-subtotal.dark {{ money(order.total * .95) }}

    .row-container.totals.before
      .row-complete.right Antes del {{ date(addDays(order.createdAt, 16)) }} (-10%):
      .product-row-subtotal.dark {{ money(order.total * .9) }}

  .remission-sign
    .remission-made
      .remission-made-sign
      div Realizó
    .remission-receives
      .remission-receives-sign
      div Recibe
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'

export default {
  name: 'PrintRemission',

  mixins: [mForm, mFilters],

  data () {
    return {
      indexOrder: -1,
      productsByArticle: []
    }
  },

  mounted () {
    this.indexOrder = this.$route.query.index
    this.doResumeRemissionByArticle()
  },

  methods: {
    addDays (date, days) {
      const newDate = new Date(date)
      newDate.setDate(newDate.getDate() + days)
      return newDate.toString()
    },
    personSpanish (value) {
      const spanish = { man: 'hombre', woman: 'mujer', boy: 'niño', girl: 'niña', adult: 'adulto', child: 'niños', all: 'general' }
      return spanish[value] || value
    },

    articleSpanish (value) {
      const spanish = { shirt: 'camiseta', hoddie: 'buzo capota', sweater: 'buzo', ziphoddie: 'buzo cremallera', drill: 'drill', jean: 'jean', socks: 'medias', jogger: 'jogger', cap: 'gorra', sneakers: 'tennis', wallet: 'billetera', beanie: 'beanie' }
      return spanish[value] || value
    },

    doResumeRemissionByArticle () {
      const products = this.order.cart
      const articles = {}

      products.forEach(product => {
        const { article, design, priceWholesaler, quantityCart } = product
        const articleSpanish = this.articleSpanish(article)

        if (!articles[`${articleSpanish} - ${design}`]) {
          articles[`${articleSpanish} - ${design}`] = { id: this.productsByArticle.length - 0 }
          this.productsByArticle.push({
            article: `${articleSpanish} - ${design}`,
            price: priceWholesaler,
            quantity: 0
          })
        }

        const id = articles[`${articleSpanish} - ${design}`].id
        const quantity = quantityCart.reduce((total, quantity) => total + (quantity || 0), 0)

        this.productsByArticle[id].quantity += quantity
      })

      console.log(this.productsByArticle)
    }
  },

  computed: {
    order () {
      if (this.indexOrder >= 0 && this.indexOrder) return this.$store.state.data.orderWholesalers.data.docs[this.indexOrder]
      return ''
    },
  
  }
}
</script>

<style lang="stylus" scoped>
.remission-container
  width 21.59cm
  background-color white
  color black
  padding 1cm
  font-size 3.5mm
  height 27cm
  position relative

.logo
  height 8mm

.remission-subtitle
  font-weight 600
  font-size 4mm

.top-remission-container
  display flex
  justify-content space-between
  margin 5mm 0

.customer-container
  text-align left

.order-container
  text-align right

.row-container, .row-container-title
  display flex
  justify-content space-between
  padding .5mm 0

.row-container-title
  margin-bottom .2em

.row-container
  border-top .5mm solid black

.row-container.totals, .row-container-title
  font-weight 600

.row-container.before
  border none

.order-totals.explication
  margin-top 1cm

.product-row-quantity, .product-row-reference, .product-row-price, .product-row-subtotal
  flex-basis 16%

.row-complete
  flex-basis: 84%

.product-row-description
  flex-basis 36%
  text-align left

.product-row-reference
  text-align left

.product-row-subtotal
  text-align right

.remission-sign
  display flex
  justify-content space-around
  position absolute
  bottom 2cm
  left 0
  width 100%

.remission-made, .remission-receives
  flex-basis 50%

.remission-made-sign, .remission-receives-sign
  width 50%
  height 30mm
  border-bottom .5mm solid black
  display inline-block
</style>



// WEBPACK FOOTER //
// src/components/pages/print/PrintRemission.vue